import { PaperFrameStyled } from '@/components/common/paperFrameStyled';
import { PaperProps } from '@mui/material';
import Box from '@mui/material/Box';
import { forwardRef, PropsWithChildren } from 'react';

export type ContentContainerVariant = 'widget' | 'page' | 'flyout';

interface WidgetContainerProps extends PaperProps {
  container: ContentContainerVariant;
  hasCustomPadding?: boolean;
}

export const WIDGET_PADDING = 3;

/**
 * Content contained on a:
 * - page (not embedded) - no additional styling
 * - flyout - no additional styling
 * - widget - wrapped in a `PaperFrameStyled`
 */
export const ContentContainer = forwardRef<
  HTMLDivElement,
  PropsWithChildren<WidgetContainerProps>
>(({ container, children, hasCustomPadding = false, ...rest }, ref) => {
  if (container === 'page' || container === 'flyout') {
    return <Box ref={ref}>{children}</Box>;
  }

  const defaultStyle = {
    ...{ p: hasCustomPadding ? 0 : 3, pb: hasCustomPadding ? 0 : 4 },
  };
  const { sx } = rest;

  return (
    <PaperFrameStyled
      {...rest}
      ref={ref}
      // eslint-disable-next-line @typescript-eslint/no-misused-spread
      sx={{ ...defaultStyle, ...sx }}
    >
      {children}
    </PaperFrameStyled>
  );
});

ContentContainer.displayName = 'ContentContainer';
